import { Furigana } from "~/components/common/Furigana";
import { H4 } from "~/components/common/Typography";
import { Separator } from "~/components/ui/separator";
import { cn } from "~/lib/utils";
import { type ExampleList } from "~/server/db/lemmas/schema";

export default function CardExamplesSection({
  examples,
  highlightWord,
  className,
}: {
  examples: ExampleList | null;
  highlightWord: string;
  className?: string;
}) {
  if (!examples || examples.length === 0) return null;

  return (
    <div className={cn("space-y-4", className)}>
      <Separator className="" />
      <H4 className="text-sm">Examples</H4>
      <ul className="space-y-4">
        {examples.map((example) => (
          <li key={`${example.ja}-${example.en}`}>
          <p className="mb-1">
            <Furigana rubyContent={example.ja} highlightWord={highlightWord} />
          </p>
          <p className="mt-1 text-sm text-muted-foreground">{example.en}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
